export enum HeaderTabs {
    Details = 'details',
    ActivityLog = 'activityLog',
}
